<template>
  <div class="p_export_report">
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>导出记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="expRecordTable">
        <el-table :data="tableData" class="re_table" :max-height="tableHeight-180" v-loading="listLoading" element-loading-text="导出记录生成中" element-loading-spinner="el-icon-loading">
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="导入名称" fit :show-overflow-tooltip="true" prop="StrOutCustName" min-width="100px">
            <template slot-scope="{row}">
              <span>{{row.StrOutCustName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" fit :show-overflow-tooltip="true" prop="StrOutCustName" min-width="100px">
            <template>
              <span>杰博</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="格式" prop="DtImpDate" min-width="80px">
            <template>xlsx</template>
          </el-table-column>
          <el-table-column align="center" label="操作人员" prop="Username" width="100px"></el-table-column>
          <el-table-column align="center" label="操作时间" prop="DtImpDate" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.DtImpDate)?row.DtImpDate.replace(/T/, " ").substring(0,19):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" min-width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.path">已生成</span>
              <span v-if="isNull(scope.row.path)&&(new Date().getTime() < new Date((new Date(scope.row.DtImpDate.length>=19?scope.row.DtImpDate.substring(0,19):scope.row.DtImpDate)).valueOf() + (scope.row.StrOutCustName.indexOf('全员导出')==-1 ? 360000 : 1200000)).getTime())">
                <i class="el-icon-loading"></i>
                <span>正在生成中</span>
              </span>
              <span v-if="(new Date().getTime() > new Date((new Date(scope.row.DtImpDate.length>=19?scope.row.DtImpDate.substring(0,19):scope.row.DtImpDate)).valueOf() + (scope.row.StrOutCustName.indexOf('全员导出')==-1 ? 360000 : 1200000)).getTime())&&isNull(scope.row.path)">
                <span>导出失败</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" prop="StrOperType" min-width="100px">
            <template slot-scope="scope">
              <div class="injuryTabBtn">
                <el-button type="text" v-if="scope.row.path" @click="downFile(scope.row.path,scope.row.StrOutCustName)">下载</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="totalcount>0&&qStstus==''">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="infoQuery.currpage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "./../../../common";
  // import ResourceComTabs from "./resImportRecord.vue"
  export default {
    name: "resExportRecord",
    data() {
      return {
        //角色类型
        roleType: localStorage.loginRoletype,
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        listLoading: false,
        currpage: 1,
        totalcount: null,
        //下拉筛选
        showDropScreen: -1,
        currentPage3: 1,
        currentPage1: 1,
        tableData: [],
        infoQuery: {
          pagecount: 10,
          currpage: 1,
          tableid: "JB_emp_UserBase,JB_busi_PsnBase,JB_busi_PsnBaseStatus,JB_busi_PsnBaseStatistics,JB_busi_PsnBaseImperr,JB_emp_PsnStatus,JB_emp_UserBaseerr,JB_busi_PsnBaseImperr,JB_emp_UserBaseout,JB_emp_OutPerson",
          custname: "",
          datestart: "",
          dateend: ''
        },
        pagecount: 10,
        pageSize: 10,
        //定时器
        interval: null,
        activeName: '导入导出记录',
        tabids: []
      }
    },
    props: ['custname', 'qStstus'],
    created() {
      if (!this.isNull(this.$route.query.active)) {
        this.activeName = this.$route.query.active
      } else {
        this.activeName = '导入导出记录'
      }
      this.roleType = localStorage.loginRoletype
      this.calHeight();
    },
    mounted() {
      (this.qStstus) ? (this.timeOut()) : (this.getExportRecord(this.infoQuery));
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        //   console.log('height',this.tableHeight)
      },
      //确保生成的一条数据是最新导出的
      timeOut() {
        this.listLoading = true
        setTimeout(() => {
          this.getlastexp()
        }, 3000)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //翻页
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currpage = `${val}`;
        this.infoQuery.currpage = Number(val)
        this.getExportRecord(this.infoQuery)
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.infoQuery.pagecount = Number(val);
        this.pageSize = parseInt(val);
        this.getExportRecord(this.infoQuery)
      },
      //获取最新一条导出记录
      async getlastexp() {
        clearInterval(this.interval)
        var custname = this.custname;
        this.listLoading = true
        xz.getPsnDataOutStatus(encodeURIComponent(custname)).then(res => {
          //  console.log('res',res)
          this.tableData = []
          if (res.status == 'ok') {
            this.tableData.push(res.msg);
            if (res.msg.StrOutPath) {
              var d = res.msg.StrOutPath
              d = d.replace("\"", "").replace("\"", "")
              var path = this.tablePath + d
              this.$set(this.tableData[0], "path", path);
              this.clear()
            } else {
              this.interval = setInterval(this.getlastexp, 10000);
            }
            this.listLoading = false
          } else {
            //清除定时器
            this.listLoading = true
            this.tableData = []
            this.interval = setInterval(this.getlastexp, 10000);
          }
        })
      },
      //导出记录历史
      getExportRecord(data) {
        this.listLoading = true
        this.infoQuery = data;
        xz.getPsnDAtaOutList(data).then(res => {
          // console.log('res',res)
          if (res.msg.length > 0) {
            res.msg.forEach(l => {
              if (l.StrOutPath) {
                var d = l.StrOutPath;
                d = d.replace("\"", "").replace("\"", "")
                var path = this.tablePath + d
                this.$set(l, "path", path);
              }
            });
            this.tableData = res.msg;
            this.totalcount = parseInt(res.totalcount);
            if (res.Isrefresh != '0') {
              setTimeout(() => {
                this.getExportRecord(data)
              }, 10000);
            }
          } else {
            this.tableData = []
            this.totalcount = 0
          }
          this.listLoading = false
        })
      },
      // 清除定时器的代码
      clear() {
        clearInterval(this.interval);
        this.interval = null
      },
      downFile(url, name) {
        var path =  url;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', name);
        aTag.click();
      },
    },
    beforeDestroy() {
      // 在页面销毁后，清除计时器
      this.clear()
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
  .re_table.el-table .el-table__cell {
    padding: 3px 0;
  }

  .p_export_report .el-tabs--top {
    background-color: #fff;
  }

  .screenInput .el-input {
    width: 70%;
    margin-left: 5px;
  }

  .formScreenInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .formScreenInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .p_roster_table.el-tabs--card {
    background-color: #fff;
  }
</style>